const ShowTreeRootOptions = {
    ALWAYS: "ALWAYS",
    NEVER: "NEVER",
    IF_ROOT_ONLY: "IF_ROOT_ONLY",
}

export default ShowTreeRootOptions;